<script>
    import {getGPTransFunc} from "./gp-translations.js";
    let trans = getGPTransFunc("gp-calibrator");
    import GPCalibratorModel from "./gp-calibrator-model.svelte";
    import jQuery from "jquery";

    let calculatedHorizon = 0.5;
    let calculatedScale = 0.6;
    let rotatedCanvas = null;
    let attempt = 0;
    let attempts = 2;
    let scales = Array(attempts).fill(0.5);
    let distYS = Array(attempts).fill(0);
    let scale = 0.6;
    let distY = 0;
    let prevAreaHeight;
    $: recalculate(scale);

    export function open(uri) {
        jQuery('#GPBackgroundCalibrate').on('hidden.bs.modal', () => this.$destroy());

        //manage focus
        jQuery('#GPBackgroundCalibrate').on('hidden.bs.modal', GP.restoreFocus);

        //trap focus
        jQuery('#GPBackgroundCalibrate .modal-header .close').on('keydown', function(e) {if (e.shiftKey && e.which===9) e.preventDefault();});

        var img = new Image;
        img.onload = function(){
            openImage(img);
        };
        img.onerror = function () {
            alert("Image failed to load");
        };
        img.src = uri;
    }

    function openImage(image) {

        jQuery('#GPBackgroundCalibrate').off('shown.bs.modal').on('shown.bs.modal',onResize);
        jQuery('#GPBackgroundCalibrate').modal({});

        var resizedWidth = image.width;
        var resizedHeight = image.height;
        if (resizedWidth>GPSettings.maxAllowedWidth) {
            resizedHeight = resizedHeight * GPSettings.maxAllowedWidth / resizedWidth;
            resizedWidth = GPSettings.maxAllowedWidth;
        }

        rotatedCanvas = document.createElement('canvas');
        rotatedCanvas.width  = resizedWidth;
        rotatedCanvas.height = resizedHeight;
        var ctx = rotatedCanvas.getContext('2d');
        ctx.drawImage(image, 0, 0, resizedWidth, resizedHeight);

        var img = jQuery('#GPBackgroundPreview')[0];
        var dataURL = rotatedCanvas.toDataURL();
        img.onload = onResize;
        img.src=dataURL;
    }
    
    function rotate (direction) {
        var canvas = document.createElement('canvas');
        canvas.width = rotatedCanvas.height;
        canvas.height = rotatedCanvas.width;

        var ctx = canvas.getContext("2d");
        ctx.translate(canvas.width / 2, canvas.height / 2);

        ctx.rotate(direction * Math.PI / 2);
        ctx.drawImage(rotatedCanvas, -rotatedCanvas.width / 2, -rotatedCanvas.height / 2);
        ctx.rotate(-direction * Math.PI / 2);
        ctx.translate(-canvas.width / 2, -canvas.height / 2);
        
        rotatedCanvas.width = canvas.width;
        rotatedCanvas.height = canvas.height;
        rotatedCanvas = canvas;

        var img = jQuery('#GPBackgroundPreview')[0];
        var dataURL = rotatedCanvas.toDataURL();
        img.onload = onResize;
        img.src=dataURL;
    }



    function applyParams() {
        var img = jQuery('#GPBackgroundPreview')[0];
        var imgsrc;
        if ( typeof img.currentSrc === "undefined" )
            imgsrc = img.src;
        else
            imgsrc = img.currentSrc;
        GP.loadImageAsBackground(imgsrc, 1 - calculatedHorizon,  3 / calculatedScale );

        //Survicate
        if (document.location.href.indexOf("lang=pl") < 0 && typeof _sva === 'object' && typeof _sva.invokeEvent === 'function') {
           _sva.invokeEvent('survey_calibration');
        }
    }

    function recalculate() {
        scales[attempt] = scale;
        distYS[attempt] = distY;
        if (attempt > 0) {

            let x = distYS.slice(0, attempt+1);
            let y = scales.slice(0, attempt+1);
            let regression = linearRegression(x, y);

            calculatedHorizon = 1 - distYS[attempt] / (1 - regression.predictedY[attempt] / regression.predictedY[0]);
            calculatedScale = regression.predictedY[0];
        }
    }

    function linearRegression(x, y) {
        const n = x.length; // Liczba punktów

        // Obliczanie sum potrzebnych do wyznaczenia współczynników a i b
        let sumX = 0, sumY = 0, sumXY = 0, sumX2 = 0;

        for (let i = 0; i < n; i++) {
            sumX += x[i];
            sumY += y[i];
            sumXY += x[i] * y[i];
            sumX2 += x[i] * x[i];
        }

        // Obliczenie współczynnika a (nachylenie)
        const a = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);

        // Obliczenie współczynnika b (przecięcie z osią y)
        const b = (sumY - a * sumX) / n;

        // Obliczanie przewidywanych wartości y na podstawie wyznaczonej prostej
        const predictedY = x.map(xi => a * xi + b);

        return {
            a: a,            // Nachylenie prostej
            b: b,            // Przecięcie z osią y
            predictedY: predictedY // Przewidywane wartości y (e_yi)
        };
    }

    function saveAttempt() {
        recalculate();
        distY += 0.05;
        attempt++;
        scale = scale * 0.9;
    }

    function rollbackAttempt() {
        attempt--;
        scale = scales[attempt];
        distY = distYS[attempt];
    }


    function onResize() {
        jQuery('#GPBackgroundPreviewArea').css('width', 'auto');
        jQuery('#GPBackgroundPreviewArea').css('height', 'auto');
        // Get the parent element
        var parentElement = document.getElementById('GPBackgroundPreviewArea').parentElement;

        // Get the computed styles of the parent element
        var computedStyle = window.getComputedStyle(parentElement);

        // Calculate the padding values
        var paddingLeft = parseFloat(computedStyle.paddingLeft);
        var paddingRight = parseFloat(computedStyle.paddingRight);
        var paddingTop = parseFloat(computedStyle.paddingTop);
        var paddingBottom = parseFloat(computedStyle.paddingBottom);

        // Calculate the available width and height by subtracting the padding
        var availableWidth = parentElement.clientWidth - paddingLeft - paddingRight;
        var availableHeight = parentElement.clientHeight - paddingTop - paddingBottom;

        jQuery('#GPBackgroundPreviewArea').css('height', availableHeight);
        jQuery('#GPBackgroundPreviewArea').css('width', availableWidth);

    }
    
</script>

<svelte:window on:resize={onResize} />

<div class="modal fade GPModal" tabindex="-1" id="GPBackgroundCalibrate">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">
                    {trans("Adjust the image scale")}
                </h4>
            </div>
            <div class="modal-body">
                <div>
                    <div bind:clientHeight={prevAreaHeight} id="GPBackgroundPreviewArea">
                        <img id="GPBackgroundPreview"/>
                        {#if attempt > 1}
                        <div id="GPBackgroundHorizon" style="top: {100 * calculatedHorizon}%"></div>
                        {/if}
                        <GPCalibratorModel bind:scale prevAreaHeight={prevAreaHeight} distY={distY}/>
                        <a href="#" class="resize-bigger" on:click={() => scale *= 1.1}>
                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21ZM12.1603 4.29545H8.96536V9.20745H4.06707V12.3066H8.96536V16.7045H12.1603V12.3066H16.9331V9.20745H12.1603V4.29545Z" fill="white"/>
                                </svg>
                        </a>
                        <a href="#" class="resize-smaller" on:click={() => scale /= 1.1}>
                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21ZM16.9331 12.3066V9.20745H4.06707V12.3066H16.9331Z" fill="white"/>
                            </svg>
                        </a>
                    </div>
                </div>
                {#if attempt === 0}
                <b id="GPBackgroundCallToAction">
                    {trans("Scale the gardener to look natural. Resize by dragging the upper corner or use +/- buttons.")}
                </b>
                {:else}
                <b id="GPBackgroundCallToAction">
                    {trans("Repeat the calibration with the gardener positioned a bit farther away.")}
                </b>
                {/if}
            </div>
           <div class="modal-footer">
                {#if attempt === 0}
                    <button on:click={()=>rotate(-1)} id="GPBackgroundRotateLeft" type="button" class="btn btn-default" >&#8634;</button>
                    <button on:click={()=>rotate(1)} id="GPBackgroundRotateRight" type="button" class="btn btn-default" >&#8635;</button>
                {/if}
                <button type="button" class="btn btn-default" data-dismiss="modal" >{trans("Cancel")}</button>
                {#if attempt > 0}
                    <button on:click={rollbackAttempt} type="button" class="btn btn-default" >&laquo; {trans("Back")}</button>
                {/if}
                {#if attempt < attempts}
                    <button on:click={saveAttempt} type="button" class="btn btn-primary" >{trans("Next")} &raquo;</button>
                {/if}
                {#if attempt === attempts}
                    <button on:click={applyParams} type="button" class="btn btn-primary" data-dismiss="modal">{trans("Apply")}</button>
                {/if}
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->         